import React, { Suspense, useCallback, useState } from "react";
import { PostImagesContainer } from "./styles";
const ImagesZoom = React.lazy(() => import("../ImagesZoom"));
// import ImagesZoom from "../ImagesZoom";

const PostImages = ({ images }) => {
  const [showImagesZoom, setShowImagesZoom] = useState(false);

  const onZoom = useCallback(() => {
    setShowImagesZoom(true);
  }, []);

  const onClose = useCallback(() => {
    setShowImagesZoom(false);
  }, []);

  if (images.length === 1) {
    return (
      <>
        <PostImagesContainer className="img-1">
          <img
            role="presentation"
            src={images[0]}
            alt="blob url img"
            onClick={onZoom}
          />
        </PostImagesContainer>
        <Suspense fallback={<h2>loading...</h2>}>
          {showImagesZoom && <ImagesZoom images={images} onClose={onClose} />}
        </Suspense>
      </>
    );
  }
  if (images.length === 2) {
    return (
      <>
        <PostImagesContainer className="img-2">
          <br />
          <img
            role="presentation"
            src={images[0]}
            alt="blob url img"
            onClick={onZoom}
          />
          <img
            role="presentation"
            src={images[1]}
            alt="blob url img"
            onClick={onZoom}
          />
        </PostImagesContainer>
        <Suspense fallback={<h2>loading...</h2>}>
          {showImagesZoom && <ImagesZoom images={images} onClose={onClose} />}
        </Suspense>
      </>
    );
  }

  return (
    <>
      <PostImagesContainer className="img-3">
        <br />
        <img
          role="presentation"
          src={images[0]}
          alt="blob url img"
          onClick={onZoom}
        />

        <img
          className="img2"
          role="presentation"
          src={images[1]}
          alt="blob url img"
          onClick={onZoom}
        />

        {images.length > 2 && (
          <div>
            <span>+</span>
            <span>{images.length - 1}</span>
          </div>
        )}
      </PostImagesContainer>
      <Suspense fallback={<h2>loading...</h2>}>
        {showImagesZoom && <ImagesZoom images={images} onClose={onClose} />}
      </Suspense>
    </>
  );
};

export default PostImages;
